import styled from "styled-components";
import { media } from "../../styles/breakpoints";

const DetailStyled = styled.div`
  width: 100%;
  height: 100%;
  padding-bottom: 80px;
  max-width: 800px;
  margin: 0 auto;

  ${media.tablet`
    padding-bottom: 100px;
  `}

  .detail {
    &__image {
      width: 100%;
      height: 250px;
      object-fit: cover;
      border-radius: ${(props) => props.theme.border.borderRadiusLarge};
      box-shadow: ${(props) => props.theme.shadows.medium};
      margin-bottom: ${(props) => props.theme.spacing.lg};

      ${media.tablet`
        height: 300px;
        margin-bottom: 32px;
      `}

      ${media.desktop`
        height: 350px;
      `}
    }

    &__image--fill {
      width: 100%;
      height: 250px;
      object-fit: fill;
      border-radius: ${(props) => props.theme.border.borderRadiusLarge};
      box-shadow: ${(props) => props.theme.shadows.medium};
      margin-bottom: ${(props) => props.theme.spacing.lg};

      ${media.tablet`
        height: 300px;
        margin-bottom: 32px;
      `}

      ${media.desktop`
        height: 350px;
      `}
    }

    &__title {
      padding: ${(props) => props.theme.spacing.md} 0;
      font-size: ${(props) => props.theme.fonts.titleFontSizeL};
      font-weight: ${(props) => props.theme.fonts.fontWeightBold};
      color: ${(props) => props.theme.colour.text.primary};
      line-height: ${(props) => props.theme.fonts.lineHeightTight};
      margin-bottom: ${(props) => props.theme.spacing.lg};
      text-align: center;

      ${media.tablet`
        font-size: 2.5rem;
        margin-bottom: 32px;
      `}
    }

    &__info {
      display: flex;
      flex-direction: column;
      gap: ${(props) => props.theme.spacing.md};
      margin-bottom: ${(props) => props.theme.spacing.xl};
      padding: ${(props) => props.theme.spacing.lg};
      background-color: ${(props) => props.theme.colour.background.secondary};
      border-radius: ${(props) => props.theme.border.borderRadiusLarge};
      border: 1px solid ${(props) => props.theme.colour.border.light};

      ${media.tablet`
        gap: 24px;
        padding: 32px;
      `}

      > li {
        display: flex;
        align-items: center;
        gap: ${(props) => props.theme.spacing.md};
        font-size: ${(props) => props.theme.fonts.textFontSizeM};
        color: ${(props) => props.theme.colour.text.primary};
        padding: ${(props) => props.theme.spacing.sm} 0;
        border-bottom: 1px solid ${(props) => props.theme.colour.border.light};

        &:last-child {
          border-bottom: none;
        }

        ${media.tablet`
          font-size: 1.5rem;
          padding: 16px 0;
        `}

        > span {
          flex: 1;
          font-weight: ${(props) => props.theme.fonts.fontWeightMedium};
        }

        > svg {
          height: 24px;
          width: 24px;
          color: ${(props) => props.theme.colour.brand.primary};
          flex-shrink: 0;

          ${media.tablet`
            height: 28px;
            width: 28px;
          `}
        }
      }
    }

    &__buttons {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: ${(props) => props.theme.spacing.md};
      background-color: ${(props) => props.theme.colour.background.dark};
      box-shadow: ${(props) => props.theme.shadows.large};
      z-index: ${(props) => props.theme.zIndex.fixed};
      border-top: 1px solid ${(props) => props.theme.colour.border.medium};

      ${media.tablet`
        padding: 24px;
      `}

      > * {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: ${(props) => props.theme.spacing.sm}
          ${(props) => props.theme.spacing.md};
        background-color: ${(props) => props.theme.colour.interactive.primary};
        color: ${(props) => props.theme.colour.text.inverse};
        border: none;
        border-radius: ${(props) => props.theme.border.borderRadiusSmall};
        cursor: pointer;
        transition: ${(props) => props.theme.transitions.normal};
        min-height: 48px;
        min-width: 48px;
        font-size: ${(props) => props.theme.fonts.textFontSizeS};
        font-weight: ${(props) => props.theme.fonts.fontWeightMedium};

        ${media.tablet`
          padding: 16px 24px;
          font-size: 1.25rem;
          min-width: 120px;
        `}

        &:hover {
          background-color: ${(props) => props.theme.colour.interactive.hover};
          transform: translateY(-1px);
          box-shadow: ${(props) => props.theme.shadows.small};
        }

        &:focus-visible {
          outline: 2px solid ${(props) => props.theme.colour.text.inverse};
          outline-offset: 2px;
        }

        svg {
          height: 24px;
          width: 24px;
          margin-right: ${(props) => props.theme.spacing.xs};

          ${media.tablet`
            height: 28px;
            width: 28px;
            margin-right: 8px;
          `}
        }
      }
    }
  }

  /* Estilos para contenido colapsable */
  .wrap-collabsible {
    margin: ${(props) => props.theme.spacing.lg} 0;
  }

  .lbl-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: ${(props) => props.theme.fonts.fontWeightBold};
    font-size: ${(props) => props.theme.fonts.textFontSizeL};
    padding: ${(props) => props.theme.spacing.lg};
    color: ${(props) => props.theme.colour.text.inverse};
    background: ${(props) => props.theme.colour.brand.primary};
    cursor: pointer;
    border-radius: ${(props) => props.theme.border.borderRadiusLarge};
    transition: ${(props) => props.theme.transitions.normal};
    border: none;
    width: 100%;
    text-align: left;

    ${media.tablet`
      font-size: 1.875rem;
      padding: 32px;
    `}

    &:hover {
      background: ${(props) => props.theme.colour.interactive.hover};
      transform: translateY(-1px);
      box-shadow: ${(props) => props.theme.shadows.small};
    }

    &:focus-visible {
      outline: 2px solid ${(props) => props.theme.colour.border.focus};
      outline-offset: 2px;
    }

    &::after {
      content: "";
      display: inline-block;
      width: 0;
      height: 0;
      border-left: 8px solid currentColor;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      transition: ${(props) => props.theme.transitions.normal};
      margin-left: ${(props) => props.theme.spacing.sm};
    }
  }

  .toggle:checked + .lbl-toggle::after {
    transform: rotate(90deg);
  }

  .collapsible-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height ${(props) => props.theme.transitions.normal};
  }

  .toggle:checked + .lbl-toggle + .collapsible-content {
    max-height: 500px;
  }

  .collapsible-content .content-inner {
    background: ${(props) => props.theme.colour.background.secondary};
    border: 1px solid ${(props) => props.theme.colour.border.light};
    border-top: none;
    border-bottom-left-radius: ${(props) =>
      props.theme.border.borderRadiusLarge};
    border-bottom-right-radius: ${(props) =>
      props.theme.border.borderRadiusLarge};
    padding: ${(props) => props.theme.spacing.lg};
    margin-top: -${(props) => props.theme.spacing.sm};

    ${media.tablet`
      padding: 32px;
    `}

    p {
      margin: 0 0 ${(props) => props.theme.spacing.md} 0;
      line-height: ${(props) => props.theme.fonts.lineHeightRelaxed};
      color: ${(props) => props.theme.colour.text.primary};

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  /* Ocultar checkbox */
  input[type="checkbox"] {
    display: none;
  }
`;

export default DetailStyled;
